import React, { useState, useEffect } from "react";
import axios from "axios";
import {
  FaWhatsapp,
  FaPhoneAlt,
  FaEnvelope,
  FaMapMarkerAlt
} from "react-icons/fa";
import API_BASE_URL from "../config";
import { toast } from "react-toastify";

const Contactsection = () => {
  const [siteInfo, setSiteInfo] = useState();
  const [error, setError] = useState();
  const [loading, setLoading] = useState(true);

  // Form state
  const [firstName, setFirstName] = useState("");
  const [lastName, setLastName] = useState("");
  const [email, setEmail] = useState("");
  const [contactNo, setContactNo] = useState("");
  const [inquiry, setInquiry] = useState("");
  const [submitMsg, setSubmitMsg] = useState("");

  useEffect(() => {
    fetchSiteInfo();
  }, []);

  const fetchSiteInfo = async () => {
    try {
      const response = await axios.get(`${API_BASE_URL}home/info`);
      if (response.data.success) {
        setSiteInfo(response.data.data);
      } else {
        setError("Failed to fetch site information");
      }
    } catch (err) {
      setError("Error fetching site information");
      console.error("API Error:", err);
    } finally {
      setLoading(false);
    }
  };

  const contactformsubmit = async (e) => {
    e.preventDefault();
    setSubmitMsg(""); // reset previous message
    setError("");

    if (!firstName || !lastName || !email || !contactNo || !inquiry) {
      toast.warn("Please fill all required fields.");
      return;
    }
    if (contactNo.length < 9 || contactNo.length > 15) {
      toast.warn("Contact number must be between 9 and 15 digits.");
      return;
    }
    try {
      const response = await axios.post(`${API_BASE_URL}user/contact`, {
        first_name: firstName,
        last_name: lastName,
        email: email,
        contact_no: contactNo,
        inquiry: inquiry
      });

      if (response.data.success) {
        toast.success("Your message has been sent successfully!");
        // Clear form
        setFirstName("");
        setLastName("");
        setEmail("");
        setContactNo("");
        setInquiry("");
      } else {
        toast.error("Failed to submit form. Please try again.");
      }
    } catch (err) {
      console.error("Contact form submit error:", err);
      toast.error("Something went wrong. Please try again later.");
    }
  };

  return (
    <>
      <section className="innerbanner"></section>
      <section className="contactcontainer">
        <div className="container">
          <div className="row justify-content-center">
            <div className="col-xl-10 col-md-12 col-sm-12 col-12">
              <div className="ctformbox">
                <div className="row gx-lg-5 justify-content-between">
                  <div className="col-xl-6 col-lg-6 col-md-6 col-sm-12 col-12 pl-0 pr-0 order-xl-1 order-md-1 mb-4 mb-md-0">
                    <div className="lblright">
                      <div className="lblrightinner">
                        <div className="innerbox signupbox">
                          <div className="section-heading">
                            <h2 className="mb-1">Send Us a Message</h2>
                            <p>Tell us what you need — our team will reply as soon as possible.</p>
                          </div>
                          <div className="lform">
                            {error && <div className="text-danger mb-2">{error}</div>}
                            {submitMsg && <div className="text-success mb-2">{submitMsg}</div>}
                            <form className="lform" onSubmit={contactformsubmit}>
                              <div className="row gx-2 gx-lg-3">
                                <div className="col-xl-6 col-md-6 col-sm-12 col-12">
                                  <div className="form-group">
                                    <label>
                                      First Name <span className="text-danger">*</span>
                                    </label>
                                    <input
                                      className="form-control"
                                      type="text"
                                      placeholder="First Name"
                                      value={firstName}
                                      onChange={(e) => {
                                        const value = e.target.value.replace(/[^a-zA-Z]/g, '');
                                        setFirstName(value);
                                      }}
                                    />
                                  </div>
                                </div>

                                <div className="col-xl-6 col-md-6 col-sm-12 col-12">
                                  <div className="form-group">
                                    <label>
                                      Last Name <span className="text-danger">*</span>
                                    </label>
                                    <input
                                      className="form-control"
                                      type="text"
                                      placeholder="Last Name"
                                      value={lastName}
                                      onChange={(e) => {
                                        const value = e.target.value.replace(/[^a-zA-Z]/g, '');
                                        setLastName(value);
                                      }}
                                    />
                                  </div>
                                </div>

                                <div className="col-xl-6 col-md-6 col-sm-12 col-12">
                                  <div className="form-group">
                                    <label>Email <span className="text-danger">*</span></label>
                                    <input
                                      className="form-control"
                                      type="email"
                                      placeholder="Email"
                                      value={email}
                                      onChange={(e) => setEmail(e.target.value)}
                                    />
                                  </div>
                                </div>
                                <div className="col-xl-6 col-md-6 col-sm-12 col-12">
                                  <div className="form-group">
                                    <label>
                                      Contact Number <span className="text-danger">*</span>
                                    </label>
                                    <input
                                      className="form-control"
                                      type="tel"
                                      placeholder="Contact Number"
                                      value={contactNo}
                                      maxLength={15}
                                      onChange={(e) => {
                                        const value = e.target.value.replace(/\D/g, '');
                                        if (value.length <= 15) {
                                          setContactNo(value);
                                        }
                                      }}
                                    />
                                    {contactNo && (contactNo.length < 9 || contactNo.length > 15) && (
                                      <small className="text-danger">
                                        Contact number must be between 9 and 15 digits
                                      </small>
                                    )}
                                  </div>

                                </div>
                                <div className="col-xl-12 col-md-12 col-sm-12 col-12">
                                  <div className="form-group">
                                    <label>Comments <span className="text-danger">*</span></label>
                                    <textarea
                                      className="form-control"
                                      placeholder="Type Your Inquiry"
                                      value={inquiry}
                                      onChange={(e) => setInquiry(e.target.value)}
                                    ></textarea>
                                  </div>
                                </div>
                                <div className="col-xl-12 col-md-12 col-sm-12 col-12 text-start">
                                  <button className="theme-btn">Send Message</button>
                                </div>
                              </div>
                            </form>
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>
                  <div className="col-xl-6 col-lg-6 col-md-6 col-sm-12 col-12 pl-0 pr-0 ">
                    <div className="lboxcontent">
                      <div className="lboxcontentinner">
                        <div className="section-heading">
                          <h2 className="mb-1">Get In Touch</h2>
                          <p>Need to get in touch with us? Fill out the form and send us your question and we will get back to you within three business days.</p>
                        </div>
                        <div className="coininfo">
                          <div className="cticon"><i className="icon icon-map-marker"></i></div>
                          {siteInfo?.address && (
                            <div className="cticontent">
                              <h4>Address</h4>
                              <div dangerouslySetInnerHTML={{ __html: siteInfo.address }} />
                            </div>
                          )}
                        </div>
                        <div className="coininfo">
                          <div className="cticon"><i className="fa fa-whatsapp"></i></div>
                          <div className="cticontent">
                            <h4>Whatsapp</h4>
                            <p><a href={`https://wa.me/91${siteInfo?.support_whatsapp}`} target="_blank" rel="noopener noreferrer">(+91) {siteInfo?.support_whatsapp}</a></p>
                          </div>
                        </div>
                        <div className="coininfo">
                          <div className="cticon"><i className="icon icon-phone"></i></div>
                          <div className="cticontent">
                            <h4>Call Us</h4>
                            <p><a href={`tel:+91${siteInfo?.site_phone}`}>(+91) {siteInfo?.site_phone}</a></p>
                          </div>
                        </div>
                        <div className="coininfo">
                          <div className="cticon"><i className="fa fa-envelope-o"></i></div>
                          <div className="cticontent">
                            <h4>Drop A Mail</h4>
                            <p><a href={`mailto:${siteInfo?.site_email}`}>{siteInfo?.site_email}</a></p>
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </section>
    </>
  );
};

export default Contactsection;
